import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ApplicationStore } from '@core/store/application.store';
import { AuthService } from '@features/auth/auth.service';
import { LangDefinition, TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-language-switch',
  templateUrl: './language-switch.component.html',
  imports: [MatSelectModule, MatFormFieldModule, TranslocoModule],
})
export class LanguageSwitchComponent {
  private readonly translocoService = inject(TranslocoService);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly authService = inject(AuthService);

  readonly languageSelected: Signal<string> = this.applicationStore.getActiveLanguage;
  readonly languages: LangDefinition[] = this.translocoService.getAvailableLangs() as LangDefinition[];

  changeLanguage(event: MatSelectChange): void {
    const language: string = event.value;
    this.applicationStore.updateLanguage(language);
    this.authService.updateLanguage().subscribe();
  }
}
